var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModerateEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.567 19.75l-9.223 2.017 4.51-15.792c.391-1.373-1.444-2.252-2.267-1.083L2.598 30.45c-.676.961.205 2.25 1.346 1.97l8.218-2.023-4.495 15.807c-.387 1.362 1.416 2.23 2.248 1.107l18.947-25.558c.7-.944-.148-2.254-1.295-2.003zm-15.54 20.435l3.185-11.2a1.274 1.274 0 00-1.53-1.586L6.64 29.133l11.697-16.618-3.027 10.601c-.264.923.553 1.8 1.496 1.594l7.987-1.746-12.766 17.22z",
    fill: "#91C300",
    stroke: "#91C300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79 4.51a1.529 1.529 0 00-2.05.683L.683 11.307c-.497.994.212 2.211 1.376 2.211H5.69L3.74 17.42a1.529 1.529 0 002.734 1.367l3.057-6.113c.508-1.018-.24-2.212-1.367-2.212H4.523l1.95-3.902a1.528 1.528 0 00-.683-2.05z",
    fill: "#91C300"
  })));
}

export default SvgModerateEnergy;